(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squishystartz-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sprite = document.querySelector('[data-hero-sprite]');
  if (!sprite) return;
  const sprites = window.squishystartzSprites;
  sprite.style.color = sprites.randomColour();
  sprite.querySelector('use').setAttribute('href', `#sq-${sprites.randomFace()}`);
})();

(() => {
  const scene = document.querySelector('[data-hero-scene]');
  if (!scene) return;

  const PX = 0.8; // rem per pixel of scenery art
  const TREE_PX = 1.1; // trees are drawn larger than the ground cover
  const palette = { T: '#2E7C77', M: '#6FC29A', K: '#1E3B3A', P: '#E2779E', Y: '#E9A23B', W: '#FFFDF7' };
  const art = {
    pine: [
      '....T....',
      '...TTT...',
      '..TTTTT..',
      '...TTT...',
      '..TTTTT..',
      '.TTTTTTT.',
      '...TTT...',
      '.TTTTTTT.',
      'TTTTTTTTT',
      '....K....',
      '....K....',
      '....K....',
    ],
    round: [
      '....TTT....',
      '..TTTTTTT..',
      '.TTMMTTTTT.',
      '.TTMMTTTTT.',
      'TTTTTTTTTTT',
      'TTTTTTTTTTT',
      '.TTTTTTTTT.',
      '..TTTTTTT..',
      '.....K.....',
      '.....K.....',
      '.....K.....',
    ],
    bush: [
      '...TTTTTT...',
      '.TTMMTTTTTT.',
      'TTTTTTTTTTTT',
      'TTTTTTTTTTTT',
      '.TTTTTTTTTT.',
    ],
    grass: ['M.M.M', 'TTTTT'],
    flower: ['.P.', 'PYP', '.P.', '.K.', '.M.'],
    cloud: [
      '....WWWW......',
      '..WWWWWWWW....',
      'WWWWWWWWWWWW..',
      'WWWWWWWWWWWWWW',
      '.WWWWWWWWWWWW.',
    ],
  };

  // Ground items sit on the same line as the walker; clouds float near the top
  const items = [
    { art: 'round', left: 60, bottom: 2 },
    { art: 'pine', left: 80, bottom: 2 },
    { art: 'bush', left: 36, bottom: 2 },
    { art: 'grass', left: 31, bottom: 2 },
    { art: 'grass', left: 52, bottom: 2 },
    { art: 'grass', left: 72, bottom: 2 },
    { art: 'grass', left: 88, bottom: 2 },
    { art: 'flower', left: 47, bottom: 2 },
    { art: 'flower', left: 69, bottom: 2 },
    { art: 'cloud', left: 42, top: 3 },
    { art: 'cloud', left: 74, top: 6 },
  ];

  const toSvg = (rows) => {
    const rects = [];
    rows.forEach((row, y) => [...row].forEach((ch, x) => {
      if (palette[ch]) rects.push(`<rect x="${x}" y="${y}" width="1" height="1" fill="${palette[ch]}"/>`);
    }));
    return `<svg viewBox="0 0 ${rows[0].length} ${rows.length}" shape-rendering="crispEdges" aria-hidden="true">${rects.join('')}</svg>`;
  };

  scene.innerHTML = items.map(({ art: name, left, top, bottom }) => {
    const rows = art[name];
    const pos = top != null ? `top:${top}rem` : `bottom:${bottom}rem`;
    const cls = name === 'cloud' ? 'sq-hero__item sq-hero__cloud' : 'sq-hero__item';
    const px = name === 'pine' || name === 'round' ? TREE_PX : PX;
    return `<div class="${cls}" style="left:${left}%;${pos};width:${rows[0].length * px}rem">${toSvg(rows)}</div>`;
  }).join('');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squishystartz-parade"] && !Shopify.designMode) return;
  try {
    
(() => {
  const track = document.querySelector('[data-parade]');
  if (!track) return;

  const sprites = window.squishystartzSprites;
  const sizes = [4.4, 5.6, 7.0]; // rem: small, medium, large
  const RUN = 10;   // squishies in one random run
  const COPIES = 4; // the run is copied so the loop is seamless

  const run = [];
  for (let i = 0; i < RUN; i++) {
    const delay = (Math.random() * 0.8).toFixed(2);
    run.push(
      `<span class="sq-parade__item" style="color:${sprites.randomColour()};width:${sizes[sprites.pick(sizes.length)]}rem">` +
        `<span class="sq-parade__hop" style="animation-delay:-${delay}s"><svg viewBox="0 0 16 16" aria-hidden="true"><use href="#sq-${sprites.randomFace()}"/></svg></span>` +
        `<span class="sq-parade__shadow" style="animation-delay:-${delay}s"></span>` +
      `</span>`
    );
  }
  track.innerHTML = run.join('').repeat(COPIES);

  // Pixel art for the click burst: a heart and a sparkle
  const grids = {
    heart: ['.X.X.', 'XXXXX', 'XXXXX', '.XXX.', '..X..'],
    sparkle: ['..X..', '..X..', 'XXXXX', '..X..', '..X..'],
  };
  const pixelSvg = (rows, colour) => {
    const rects = [];
    rows.forEach((row, y) => [...row].forEach((ch, x) => {
      if (ch === 'X') rects.push(`<rect x="${x}" y="${y}" width="1" height="1"/>`);
    }));
    return `<svg viewBox="0 0 5 5" shape-rendering="crispEdges" style="color:${colour}" aria-hidden="true"><g fill="currentColor">${rects.join('')}</g></svg>`;
  };

  const parade = track.parentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  parade.addEventListener('click', (event) => {
    if (reduceMotion) return;
    const rect = parade.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    for (let i = 0; i < 5; i++) {
      const burst = document.createElement('span');
      const kind = i % 2 ? 'sparkle' : 'heart';
      const colour = i % 2 ? sprites.glow : '#E2779E';
      burst.className = 'sq-burst';
      burst.style.left = `${x}px`;
      burst.style.top = `${y}px`;
      burst.style.setProperty('--dx', `${(Math.random() * 6 - 3).toFixed(2)}rem`);
      burst.innerHTML = pixelSvg(grids[kind], colour);
      parade.appendChild(burst);
      burst.addEventListener('animationend', () => burst.remove());
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
